import AttachmentIndexPage from '@/pages/attachments/CMAttachmentsPage.vue'
import AttachmentsImport from '@/pages/attachments/CMAttachmentsImport.vue'
import AttachmentsCreateInvoice from '@/pages/attachments/CMAttachmentsCreateInvoice.vue'
import AttachmentsCreateRefund from '@/pages/attachments/CMAttachmentsCreateRefund.vue'
import DevisForm from '@/pages/attachments/DevisForm.vue'

export default [
  {
    path: '/attachments/',
    alias: ['/account/attachments/'],
    component: AttachmentIndexPage
  },
  {
    path: '/attachments/import/',
    component: AttachmentsImport
  },
  {
    path: '/attachments/createInvoice/',
    component: AttachmentsCreateInvoice
  },
  {
    path: '/attachments/createRefund/',
    component: AttachmentsCreateRefund
  },
  {
    path: '/attachments/:firstIndex/:maxResults',
    alias: ['/account/attachments/'],
    component: AttachmentIndexPage
  },
  {
    path: '/devis/create',
    component: DevisForm
  }
]
